var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sortable-collapse scrollbar-fix",
      attrs: { id: "document-list-container" },
    },
    [
      _vm.noClassifications
        ? _c(
            "no-results",
            {
              staticClass: "py-5",
              attrs: {
                "img-src": require("@Shared/@Assets/img/application-missing.png"),
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("documents.thereAreNoDocumentTypesToShowYet")) +
                  " "
              ),
              _c("br"),
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("documents.pleaseUseTheDocumentTypeDropdown")) +
                  "\n  "
              ),
            ]
          )
        : _c(
            "draggable",
            {
              key: _vm.nonce,
              staticClass: "pl-0",
              attrs: {
                animation: 200,
                "ghost-class": "ghost",
                handle: ".dropdown-item-drag-handle",
              },
              on: {
                start: function ($event) {
                  _vm.sorting = true
                },
                end: function ($event) {
                  _vm.sorting = false
                },
              },
              model: {
                value: _vm.orderedClassifications,
                callback: function ($$v) {
                  _vm.orderedClassifications = $$v
                },
                expression: "orderedClassifications",
              },
            },
            _vm._l(_vm.orderedClassifications, function (ref) {
              var documentRequestId = ref.documentRequestId
              return _c(
                "div",
                { key: documentRequestId },
                [
                  _c("document-classification-collapse", {
                    attrs: {
                      classification:
                        _vm.classifications.byId[documentRequestId],
                      documents: _vm.documents,
                      comments: _vm.comments,
                      "application-id": _vm.applicationId,
                      "client-username": _vm.clientUsername,
                      sorting: _vm.sorting,
                    },
                    on: {
                      "open-tags": function (name) {
                        return _vm.$emit("open-tags", name)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }